var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartDisplayOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7071 9.29289C29.0976 9.68342 29.0976 10.3166 28.7071 10.7071L16.7059 22.7083L11.0588 17.0613L4.70711 23.413C4.31658 23.8035 3.68342 23.8035 3.29289 23.413C2.90237 23.0225 2.90237 22.3893 3.29289 21.9988L11.0588 14.2328L16.7059 19.8799L27.2929 9.29289C27.6834 8.90237 28.3166 8.90237 28.7071 9.29289Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0277 9.02773C27.5647 8.49076 28.4353 8.49076 28.9723 9.02773C29.5092 9.5647 29.5092 10.4353 28.9723 10.9723L16.7059 23.2387L11.0588 17.5916L4.97227 23.6782C4.4353 24.2151 3.5647 24.2151 3.02773 23.6782C2.49076 23.1412 2.49076 22.2706 3.02773 21.7336L11.0588 13.7025L16.7059 19.3496L27.0277 9.02773ZM28.4419 9.55806C28.1979 9.31398 27.8021 9.31398 27.5581 9.55806L16.7059 20.4102L11.0588 14.7632L3.55806 22.2639C3.31398 22.508 3.31398 22.9037 3.55806 23.1478C3.80214 23.3919 4.19786 23.3919 4.44194 23.1478L11.0588 16.5309L16.7059 22.178L28.4419 10.4419C28.686 10.1979 28.686 9.80214 28.4419 9.55806Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartDisplayOptions);
export default __webpack_public_path__ + "static/media/chartDisplayOptions.e14b9978fdea6dfe894925cad3ff64e1.svg";
export { ForwardRef as ReactComponent };